import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { climateRiskLensSelectionState } from '@upright/ui/common/upright/core/impact-lenses/climate-risk/selection-state';
import { climateRiskLensTexts } from '@upright/ui/common/upright/core/impact-lenses/climate-risk/texts';
import {
  ClimateRiskLensData,
  ClimateRiskLensOptions,
} from '@upright/ui/common/upright/core/impact-lenses/climate-risk/types';
import { ImpactLens } from '@upright/ui/common/upright/core/impact-lenses/types';

// Path-routed lens (like Financial Effects / CSRD): the lens object carries no
// carousel content of its own — the actual sub-pages are rendered by the
// company-view climate-risk route. Only the title/description drive the rail.
export const climateRiskLens: ImpactLens<ImpactLensType.CLIMATE_RISK, ClimateRiskLensData, ClimateRiskLensOptions> = {
  type: ImpactLensType.CLIMATE_RISK,
  ImpactDataComponent: { component: () => <></> },
  infoBoxes: {},
  ...climateRiskLensSelectionState,
  ...climateRiskLensTexts,
};
